import { Component, OnInit, Input } from '@angular/core';
import {FilterAbstractModel} from "../../../../models/FilterAbstractModel";

@Component({
  selector: 'app-claims-filter',
  templateUrl: './claims-filter.component.html',
  styleUrls: ['./claims-filter.component.scss']
})
export class ClaimsFilterComponent extends FilterAbstractModel implements OnInit {

  claims: number;

  @Input() claimsSelected: number;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.claimsSelected) {
      this.claims = this.claimsSelected;
    }
  }

  reset() {
    this.claims = null;
  }

}
